import axios from 'axios'
import { maintenanceService } from '@/services/maintenanceService'
import { getAccessToken } from '@/utils/authToken'

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

api.interceptors.request.use(
  (config) => {
    
    const token = getAccessToken()
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }

    
    const url = config.url
    if (url && url.includes('/receipts/')) {
      const receiptIdMatch = url.match(/\/receipts\/([^\/]+)/)
      if (receiptIdMatch) {
        const receiptId = receiptIdMatch[1]
        const authKey = localStorage.getItem(`receipt_auth_${receiptId}`)
        if (authKey) {
          config.headers['X-Receipt-Auth'] = authKey
        }
      }
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor for maintenance mode
api.interceptors.response.use(
  (response) => {
    // Check for maintenance mode in response headers
    const maintenanceMode = response.headers['x-maintenance-mode']
    if (maintenanceMode === 'true' && window.location.pathname !== '/maintenance-mode') {
      maintenanceService.redirectToMaintenance()
    }
    return response
  },
  (error) => {
    // Check for maintenance mode in error response
    if (error.response?.status === 503 && error.response?.data?.maintenance === true) {
      maintenanceService.checkResponseForMaintenance(error.response)
    }
    return Promise.reject(error)
  }
)

export default api
